import React from 'react'

import {
  HOMEPAGE_FIELDS,
  LOCAL_BUSINESS_FIELDS,
  PAGE_META_FIELDS,
} from '../../constants/fieldGroups.constant'
import typeConstant from '../../constants/types.constant'
import AbstractCollection from '../Abstract/AbstractCollection'

// Phase 3.1 — listing view for `type: 'slide'` filters. The list shows
// `order` so editors can quickly see and reason about the render sequence.
const Slides = function () {
  return (
    <AbstractCollection
      collectionName="Slides"
      singleCollectionName="Slide"
      notToShow={[
        'ancestorIds',
        'parentId',
        'type',
        'featured',
        'images',
        'videos',
        'content',
        'contentAr',
        'title',
        'titleAr',
        'publishedAt',
        'scheduledFor',
        ...PAGE_META_FIELDS,
        ...HOMEPAGE_FIELDS,
        ...LOCAL_BUSINESS_FIELDS,
      ]}
      toShow={['name', 'order', 'status', 'createdAt']}
      type={typeConstant.SLIDE}
    />
  )
}
export default Slides
